// extracted by mini-css-extract-plugin
export default {"homeWrapper":"home_homeWrapper__fO32G","title":"home_title__jndhp","paragraph":"home_paragraph__9U0wA"};